<template>
  <cTable
    ref="table"
    :fields="fields"
    :modals="modals"
    :header="header"
    :methods="methods"
    :footer="footer"
  >
    <template #header>
      <Tabs type="card" v-model="tabName" @on-click="handleTab">
        <TabPane :label="$t('n_process')" name="undone" />
        <TabPane :label="$t('y_process')" name="done" />
      </Tabs>
    </template>
  </cTable>
</template>

<script>
import {
  getOriPack,
  getPackWare,
  postAdd,
  postDown,
  getVirtual,
  getVirtualStatus,
  getVirtualAgentStatus,
} from "@/api/storage/ori_pack";
import { getAllClient } from "@/api/user/client";

import { getUser } from "@/api/user/internal";
import { getWarehouse } from "@/api/storage/warehouse";
import { getSelectType } from "@/api/public";
import { fieldMap } from "@/utils/util";
import { getCountry } from "@/api/system/country";
import cTable from "@/base/common/index";
export default {
  name: "ori_pack",
  components: {
    cTable,
  },
  async created() {
    this.agentStatus = (
      await getSelectType(["TRANSFER_AGENT_STATUS"])
    ).data.payload["TRANSFER_AGENT_STATUS"];
    this.planOptions = (
      await getSelectType(["OMS_ORI_PACK_PLAN"])
    ).data.payload["OMS_ORI_PACK_PLAN"];
    this.pickupOptions = (
      await getSelectType(["OMS_ORI_PACK_STATUS"])
    ).data.payload["OMS_ORI_PACK_STATUS"];
    this.header.searchs.forEach(async (item) => {
      if (item.key === "service_id")
        item.options = (
          await getUser({
            standard: "CustomerService",
          })
        ).data.payload.rows;
      if (item.key === "client_id")
        item.options = (await getAllClient()).data.payload.rows;
      if (item.key === "country_code")
        item.options = (await getCountry()).data.payload.rows;
      if (item.key === "warehouse_id")
        item.options = (await getWarehouse()).data.payload.rows;
      if (item.key === "dateType") {
        item.options = (
          await getSelectType(["PUT_SHELF_SELECT_TIME"])
        ).data.payload["PUT_SHELF_SELECT_TIME"];
        this.$refs["table"].$refs["header"].searchForm["dateType"] =
          item.options[0].value;
        // console.log(
        //   (this.$refs["table"].$refs["header"].searchForm["dateType"] =
        //     item.options[0].value)
        // );
      }
      if (item.key === "plan") {
        item.options = this.planOptions;
      }
      if (item.key === "pickupStatus") {
        item.options = this.pickupOptions;
        this.pickupOptions.forEach((it) => {
          this.pickupOptionsList[it.value] = it.label;
        });
      }
      if (item.key === "agent_status") item.options = this.agentStatus;
    });
    this.modals.updatePlan.fields.forEach(async (item) => {
      if (item.key === "agent_status") item.options = this.agentStatus;
    });
  },
  methods: {
    handleTab() {
      this.$refs["table"].resize();
      this.$refs["table"].getList(1);
      this.$refs["table"].getTable().recalculate(true);
    },
  },
  data() {
    // let planOptions = ["原包转单", "拆包上架", "自提", "销毁", "丢件"];
    return {
      agentStatus: [],
      planOptions: [],
      pickupOptions: [],
      pickupOptionsList: {},
      tabName: "undone",
      methods: {
        list: (params) => {
          params.is_process = this.tabName == "done" ? "YES" : "NO";
          return getOriPack(params);
        },
        getWarehouse,
        getAllClient,
        getPackWare,
        add: postAdd,
        down: postDown,
        getSelectType,
        getUser,
        getVirtual,
        getVirtualStatus,
        getVirtualAgentStatus,
      },
      modals: {
        virtualWarehouse: {
          methods: {
            ok({ row, close }) {
              let data = row;
              data.airway_number = data.airway_number.trim();
              this.$page
                .handleRequestMethods("getVirtual", data, true, true)
                .then((res) => {
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            title: "",
            modalBind: {
              width: 600,
            },
            formBind: {
              labelWidth: 120,
            },
            rowBind: {
              gutter: 13,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              airway_number: [
                {
                  required: true,
                  trigger: "blur",
                },
              ],
              plan: [
                {
                  required: true,
                  type: "number",
                  trigger: "change",
                },
              ],
              warehouse_id: [
                {
                  required: true,
                  type: "number",
                  trigger: "change",
                },
              ],
            },
          },
          grid: [{ airway_number: 24 }, { plan: 24 }, { warehouse_id: 24 }],
          fields: [
            {
              key: "airway_number",
              name: () => this.$t("order_number"),
              component: "Input",
              bind: {
                type: "textarea",
                rows: 5,
              },
              placeholder() {
                return this.$t("enter") + this.$t("order_number");
              },
            },
            {
              name: () => this.$t("plan"),
              key: "plan",
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("plan");
              },
              options: [],
              methods: {
                async list({ field, formData }) {
                  if (this.$modal.type === "sell") {
                    let res = (await getSelectType(["OMS_ORI_PACK_PLAN"])).data
                      .payload["OMS_ORI_PACK_PLAN"];
                    res.splice(0, 2);
                    field.options = res;
                    // formData["plan"] = res[5] && res[5].value;
                  } else {
                    let res = (
                      await getSelectType(["VIRTUAL_WAREHOUSE_TRANSFER_STATUS"])
                    ).data.payload["VIRTUAL_WAREHOUSE_TRANSFER_STATUS"];
                    field.options = res;
                  }
                  this.$forceUpdate();
                },
              },
              // disabled() {
              //   return this.$modal.type === "sell";
              // },
            },
            {
              name: () => this.$t("warehouseName1"),
              show() {
                return this.$modal.type !== "sell";
              },
              key: "warehouse_id",
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("warehouseName1");
              },
              options: [],
              methods: {
                async list({ field }) {
                  let res = (await getSelectType(["VIRTUAL_WAREHOUSE"])).data
                    .payload["VIRTUAL_WAREHOUSE"];
                  field.options = res;
                  this.$forceUpdate();
                },
              },
            },
          ],
        },
        updatePlan: {
          methods: {
            ok({ row, close }) {
              let data = row;
              data.airway_number = data.airway_number.trim();
              this.$page
                .handleRequestMethods(this.type, data, true, true)
                .then((res) => {
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            title: "",
            modalBind: {
              width: 600,
            },
            formBind: {
              labelWidth: 120,
            },
            rowBind: {
              gutter: 13,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              airway_number: [
                {
                  required: true,
                  trigger: "blur",
                },
              ],
              status: [
                {
                  required: true,
                  trigger: "change",
                },
              ],
              agent_status: [
                {
                  required: true,
                  type: "number",
                  trigger: "change",
                },
              ],
              // warehouse_id: [
              //   {
              //     required: true,
              //     type: "number",
              //     trigger: "change"
              //   }
              // ]
            },
          },
          grid: [
            { airway_number: 24 },
            { status: 24 },
            { agent_status: 24 },
            // { warehouse_id: 24 }
          ],
          fields: [
            {
              key: "airway_number",
              name: () => this.$t("order_number"),
              component: "Input",
              bind: {
                type: "textarea",
                rows: 5,
              },
              placeholder() {
                return this.$t("enter") + this.$t("order_number");
              },
            },
            {
              name: () => this.$t("exlType"),
              key: "status",
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("exlType");
              },
              options: [],
              methods: {
                async list({ field }) {
                  console.log(this);
                  let res = (await getSelectType(["VIRTUAL_WAREHOUSE_STATUS"]))
                    .data.payload["VIRTUAL_WAREHOUSE_STATUS"];
                  field.options = res;
                  this.$forceUpdate();
                },
              },
              show() {
                return this.$modal.type == "getVirtualStatus";
              },
            },
            {
              name: () => this.$t("agentT") + this.$t("exlType"),
              key: "agent_status",
              component: "Select",
              placeholder() {
                return (
                  this.$t("select") + this.$t("agentT") + this.$t("exlType")
                );
              },
              show() {
                return this.$modal.type == "getVirtualAgentStatus";
              },
              options: [],
              // methods: {
              //   async list({ field }) {
              //     console.log(this);
              //     let res = (await getSelectType(["TRANSFER_AGENT_STATUS"]))
              //       .data.payload["TRANSFER_AGENT_STATUS"];
              //     field.options = res;
              //     this.$forceUpdate();
              //   }
              // }
            },
            {
              name: () => this.$t("warehouseName1"),
              key: "warehouse_id",
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("warehouseName1");
              },
              options: [],
              methods: {
                async list({ field }) {
                  let res = (await getSelectType(["VIRTUAL_WAREHOUSE"])).data
                    .payload["VIRTUAL_WAREHOUSE"];
                  field.options = res;
                  this.$forceUpdate();
                },
              },
            },
          ],
        },
        add: {
          methods: {
            ok({ row, close }) {
              console.log(row);
              this.$page.handleRequestMethods(row.type, row).then((res) => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg,
                  duration: 5,
                });
                this.$page.getList();
                close();
              });
            },
          },
          config: {
            rules: {
              airway_number: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "bulr",
                },
              ],
              warehouse_id: [
                {
                  required: true,
                  type: "number",
                  message: "cannot be empty",
                  trigger: "change",
                },
              ],
            },
            formBind: {
              labelWidth: 100,
            },
            title: this.$t("add"),
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
          },
          grid: [{ airway_number: 24 }, { warehouse_id: 24 }],
          fields: [
            {
              key: "airway_number",
              name: () => this.$t("order_number"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("order_number");
              },
              bind: {
                type: "textarea",
                rows: 5,
              },
            },
            {
              key: "warehouse_id",
              name: () => this.$t("warehouseName1"),
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("warehouseName1");
              },
              options: [],
              // config: { label: "title", value: "id" },
              methods: {
                async list({ field, searchForm }) {
                  let res = (await getSelectType(["VIRTUAL_WAREHOUSE"])).data
                    .payload["VIRTUAL_WAREHOUSE"];
                  field.options = res;
                  // searchForm[field.key] = res[0].value;
                  this.$forceUpdate();
                },
              },
            },
          ],
        },
      },
      header: {
        searchs: [
          {
            key: "dateType",
            placeholder() {
              return this.$t("select") + this.$t("time") + this.$t("type");
            },
            component: "Select",
            options: [],
          },
          {
            key: "startTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("start") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              type: "date",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              style: {
                width: "175px",
              },
            },
            methods: {
              format({ searchForm, value, newFormData }) {
                return value ? this.format.dateFormat(value, "YYYY-MM-DD") : "";
              },
            },
          },
          {
            key: "endTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("end") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              type: "date",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              style: {
                width: "175px",
              },
            },
            methods: {
              format({ searchForm, value, newFormData }) {
                return value ? this.format.dateFormat(value, "YYYY-MM-DD") : "";
              },
            },
          },
          {
            key: "ownership",
            placeholder() {
              return this.$tz("所属公司");
            },
            component: "Select",
            options: [],
            optionsFn: "getCompanies",
            optionsKey: "",
          },
          {
            key: "pickupStatus",
            placeholder() {
              return this.$t("select") + this.$t("exlType");
            },
            component: "Select",
            show: () => {
              return this.tabName === "done";
            },
            options: [],
          },
          {
            key: "plan",
            placeholder() {
              return this.$t("select") + this.$t("plan");
            },
            component: "Select",
            options: [],
            show: () => {
              return this.tabName === "done";
            },
          },
          {
            key: "online_type",
            placeholder() {
              return this.$tz("上架类型");
            },
            component: "Select",
            options: [],
            optionsFn: "",
            optionsKey: "ONLINE_TYPE",
          },
          {
            key: "gt_day",
            placeholder() {
              return this.$t("上架天数");
            },
            component: "Input",
          },
          {
            key: "client_id",
            placeholder() {
              return this.$t("select") + this.$t("clientName");
            },
            component: "Select",
            options: [],
            config: {
              label: "account",
              value: "id",
            },
          },
          {
            key: "service_id",
            placeholder() {
              return this.$t("select") + this.$t("serviceAccount");
            },
            component: "Select",
            options: [],
            config: {
              label: "account",
              value: "id",
            },
          },
          {
            key: "warehouse_id",
            placeholder() {
              return this.$t("select") + this.$t("warehouseName1");
            },
            component: "Select",
            options: [],
            config: {
              label: "title",
              value: "id",
            },
          },
          {
            key: "agent_status",
            placeholder() {
              return this.$t("agentT") + this.$t("handle") + this.$t("exlType");
            },
            component: "Select",
            options: [],
          },
          {
            key: "country_code",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("countryName");
            },
            clearable: true,
            options: [],
            config: { label: "title", value: "code" },
            bind: {
              style: "width:150px",
            },
          },
          {
            key: "keywordsType",
            placeholder() {
              return this.$t("select") + this.$t("keywords_type");
            },
            component: "Select",
            options: [],
            methods: {
              async list({ field, searchForm }) {
                let res = (await getSelectType(["OMS_ORI_PACK_KEYWORDS"])).data
                  .payload["OMS_ORI_PACK_KEYWORDS"];
                field.options = res;
                searchForm[field.key] = res[0].value;
                this.$forceUpdate();
              },
            },
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            bind: {
              type: "textarea",
              rows: 1,
            },
            component: "Input",
          },
        ],
        btns: {
          list: [
            {
              name: () => this.$t("up"),
              type: "add",
              fnName: "add",
              id: 544,
              bind: {
                type: "primary",
                icon: "md-add",
              },
            },
            {
              name: () => this.$t("down"),
              type: "down",
              fnName: "add",
              id: 543,
              bind: {
                type: "warning",
                icon: "md-remove",
              },
            },
            // {
            //   name: () =>
            //     this.$t("virtualWH") + this.$t("push") + this.$t("plan_t"),
            //   type: "virtualWarehouse",
            //   fnName: "virtualWarehouseFun",
            //   bind: {
            //     type: "success",
            //   },
            //   id: 945,
            // },
            {
              name: () => this.$t("modify") + this.$t("process_status"),
              type: "updatePlan",
              fnName: "updatePlanFun",
              bind: {
                type: "success",
              },
              id: 944,
            },
            {
              name: () =>
                this.$t("modify") +
                this.$t("agentT") +
                this.$t("handle") +
                this.$t("exlType"),
              type: "changeStatus",
              fnName: "changeStatusFun",
              bind: {
                type: "success",
              },
              id: 944,
            },
            {
              name: () => this.$t("subplan"),
              type: "sell",
              fnName: "virtualWarehouseFun",
              bind: {
                type: "warning",
              },
              // show: () => {
              //   return this.tabName === "undone";
              // },
              id: 945,
            },
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              bind: {
                icon: "md-arrow-down",
                type: "success",
              },
              disabled() {
                return !this.selectAll.length;
              },
            },
          ],
          methods: {
            updatePlanFun() {
              this.getModal("updatePlan").open(null, function () {
                this.setTitle(this.$t("modify") + this.$t("process_status"));
              });
              this.getModal("updatePlan").type = "getVirtualStatus";
            },
            changeStatusFun() {
              this.getModal("updatePlan").open(null, function () {
                this.setTitle(
                  this.$t("modify") +
                    this.$t("agentT") +
                    this.$t("handle") +
                    this.$t("exlType")
                );
              });
              this.getModal("updatePlan").type = "getVirtualAgentStatus";
            },
            virtualWarehouseFun({ field }) {
              this.getModal("virtualWarehouse").type = field.type;
              this.getModal("virtualWarehouse").open(null, function () {
                this.setTitle(this.$t("subplan"));
              });
            },
            export() {
              this.exportExc({
                origin: true,
              });
            },
            add({ field }) {
              this.getModal("add").open(
                {
                  type: field.type,
                },
                function () {
                  this.setTitle(this.$t(field.type));
                }
              );
            },
          },
        },
      },
      footer: { pageSize: [15, 100, 500, 1000, 5000, 10000] },
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60,
          show: false,
        },
        {
          name: () => this.$t("shipperRef1"),
          key: "sku_name",
          align: "center",
          width: 150,
          header: {
            copy: true,
          },
          copy: true,
        },
        {
          name: this.$t("transfer_num"),
          key: "airway_number",
          align: "center",
          header: {
            copy: true,
          },
          width: 150,
        },
        {
          name: () => this.$t("clientName"),
          key: "client_name",
          align: "center",
          header: {
            copy: true,
          },
          width: 120,
        },
        {
          name: () => this.$t("serviceAccount"),
          key: "service_name",
          align: "center",
          minWidth: 80,
        },
        {
          name: () => this.$tz("所属公司"),
          key: "ownership_name",
          minWidth: 110,
        },
        {
          name: () => this.$t("countryCode"),
          key: "country_code",
          align: "center",
          minWidth: 80,
        },
        {
          name: () => this.$t("outboundTime"),
          key: "send_time",
          align: "center",
          minWidth: 80,
          show: () => {
            return this.tabName === "done";
          },
        },
        {
          name: () => this.$t("location"),
          key: "location",
          align: "center",
          minWidth: 80,
          methods: {
            render({ value }) {
              return value;
            },
          },
        },
        {
          name: () => this.$t("warehouseName1"),
          key: "warehouse_title",
          align: "center",
          minWidth: 80,
        },
        {
          name: () => this.$t("exlType"),
          key: "pickupStatus",
          align: "center",
          minWidth: 80,
          methods: {
            render: ({ row }) => {
              return fieldMap(this.pickupOptionsList, row.pickupStatus);
            },
          },
          render: (h, { row }) => {
            return h(
              "span",
              { style: { color: row.pickupStatus == 3 ? "red" : "" } },
              fieldMap(this.pickupOptionsList, row.pickupStatus)
            );
          },
        },
        {
          name: () => this.$t("Agent process status"),
          key: "agent_status",
          align: "center",
          minWidth: 80,
          methods: {
            render: ({ row }) => {
              return this.agentStatus[row.agent_status]
                ? this.agentStatus[row.agent_status].label
                : row.agent_status;
            },
          },
        },
        {
          name: () => this.$t("plan"),
          key: "plan",
          align: "center",
          show: () => this.tabName === "done",
          methods: {
            render: ({ row }) => {
              return this.planOptions[row.plan]
                ? this.planOptions[row.plan].label
                : row.plan;
            },
          },
          minWidth: 80,
        },
        {
          name: () => this.$tz("上架类型"),
          key: "selfType",
          minWidth: 110,
        },
        {
          name: () => this.$tz("上架天数"),
          key: "online_day",
          align: "center",
          width: 110,
        },
        {
          name: () => this.$t("onlineTime"),
          key: "onlineTime",
          align: "center",
          width: 150,
        },
        {
          name: () => this.$tz("提交时间"),
          key: "outline_time",
          align: "center",
          width: 150,
          show: () => this.tabName == "done",
        },
        {
          name: () => this.$t("subplan") + this.$t("service"),
          key: "service_name_plan",
          align: "center",
          minWidth: 80,
          show: () => this.tabName == "done",
        },
        {
          name: () => this.$t("operate"),
          key: "operator_name",
          align: "center",
          minWidth: 80,
        },
        {
          name: () => this.$t("operation") + this.$t("time"),
          key: "warehouse_time",
          align: "center",
          // show: () => this.tabName == "done",
          width: 150,
        },
      ],
    };
  },
};
</script>
<style type="text/css">
/* @page{
    size: 7cm 8cm;
  } */
</style>
<style lang="scss" scoped></style>
